import Type from "@/model/types/Type";

const type = {
    CREDITOR: 1,
    SUPPLIER: 2,
}

const list = [
    {
        value: type.CREDITOR,
        text: "Credor",
    },
    {
        value: type.SUPPLIER,
        text: "Fornecedor",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}